import React from "react";
import PaginaPublica from "../PaginasPublicas/PaginaPublica";
import { imagenesPosesionCbba } from "./imagenesPosesionCbba";

function Revista() {
  return <PaginaPublica titulo="Posesion Cochabamba" imagenes={imagenesPosesionCbba} />;
}

export default Revista;